import { styled, ResponsiveValue } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

import type { SpaceType } from '@types';

const StyledView = styled(View)(
  ({ size = '$6', vertical = false }: ISeparatorProps) => {
    if (vertical) {
      return { pl: size };
    }

    return { pt: size };
  },
);

export interface ISeparatorProps {
  size?: ResponsiveValue<SpaceType>;
  vertical?: boolean;
}

export function Separator(props: ISeparatorProps) {
  return <StyledView {...props} />;
}
